import * as eventRoutines from '../Events/eventRoutines';
import * as scheduleRoutines from './scheduleRoutines';
import { connect } from 'react-redux';
import { getActiveEventHero } from '../Events/selectors';
import { selectSessionsForItinerary } from './scheduleSelectors';
import Schedule from '../../Components/Schedule/Schedule';
function mapStateToProps(state) {
    return {
        schedule: state.schedule,
        eventHero: getActiveEventHero(state),
        sessions: selectSessionsForItinerary(state),
        sessionsLoading: state.eventwide.sessionsLoading,
        sessionsPublished: state.eventwide.sessionsPublished,
        sessionsLoaded: state.eventwide.sessionsLoaded,
    };
}

const mapDispatchToProps = {
    removeScheduleImage: scheduleRoutines.removeScheduleImage,
    saveScheduleDetailsBackground: scheduleRoutines.saveScheduleDetailsBackground,
    saveScheduleListBackground: scheduleRoutines.saveScheduleListBackground,
    publishImportedSessions: scheduleRoutines.publishImportedSessions,
    toggleHidePastEvents: scheduleRoutines.toggleHidePastEvents,
    fetchSessions: eventRoutines.fetchSessionsForEvent,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Schedule);
